/**
 * Rigo — shared avatar constant + small avatar component.
 * (Iter 92) Single source of truth so the same mascot is used in
 * the customer chat, CRM inbox, chat-bot settings, and the public
 * marketing-site widget.
 */
export const RIGO_AVATAR_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_rescigo-master-panel/artifacts/5ae8nw2a_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2012_36_56%20PM.png";

export function RigoAvatar({ size = 40, className = "", ring = true }) {
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full overflow-hidden bg-white ${
        ring ? "ring-2 ring-[#C25D38]/40" : ""
      } ${className}`}
      style={{ width: size, height: size }}
    >
      <img src={RIGO_AVATAR_URL} alt="Rigo" className="w-full h-full object-cover" />
    </div>
  );
}
